module.exports = __webpack_public_path__ + "img/logo.67c14c0a.png";